import React from "react";

const Footer = () => {
  return (
    <footer id="footer" className="footer  light-background">
      <div className="container">
        <h3 className="sitename">English Studio</h3>
        <p>
        &quot;Las palabras tienen poder: usa bien tu lengua y conquistarás el mundo.&quot;
        </p>
        <div className="social-links d-flex justify-content-center">
          <a href="https://x.com/i/flow/login?redirect_after_login=%2Fenglishstudio25" target="_blank">
            <i className="bi bi-twitter-x"></i>
          </a>
          <a href="https://www.facebook.com/profile.php?id=61572049774328" target="_blank">
            <i className="bi bi-facebook"></i>
          </a>
          <a href="https://www.instagram.com/englishstudiolive/#" target="_blank">
            <i className="bi bi-instagram"></i>
          </a>
          <a href="https://www.youtube.com/channel/UCfw931TE_sFTUrPditt_4IQ" target="_blank">
            <i className="bi bi-youtube"></i>
          </a>
          <a href="https://www.linkedin.com/in/english-studio-live-299600347/" target="_blank">
            <i className="bi bi-linkedin"></i>
          </a>
        </div>
        <div className="container">
          <div className="copyright">
            <span>Copyright</span>{" "}
            <strong className="px-1 sitename">Codechip Technologies</strong>{" "}
            <span>All Rights Reserved</span>
          </div>
          <div className="credits">
            {/* All the links in the footer should remain intact. */}
            {/* Licensing information: https://bootstrapmade.com/license/ */}
            {/* Purchase the pro version with working PHP/AJAX contact form: [buy-url] */}
            Designed and managed by <a href="">Codechip Technologies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
